import { useDropzone } from 'react-dropzone';
import uploadCloud from '../../assets/images/icon-upload-cloud.svg'

export interface IFileUploaderProps {
    onUpload: (files: Array<File>) => void;
}

export default function FileUploader(props: IFileUploaderProps) {
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles: Array<File>) => {
            props.onUpload(acceptedFiles);
        },
    });

    return (
        <div {...getRootProps()} className="dropzone">
            <input {...getInputProps()} />
            <img src={uploadCloud} alt="upload" />
            <p>Drag and drop or <span>browse</span></p>
        </div>
    );
}